import React, { useState, useEffect } from "react";
import notificationService from "../services/notificationService";
import { ListGroup, Container } from "react-bootstrap";

const NotificationsPage = () => {
    const [expiringIngredients, setExpiringIngredients] = useState([]);
    const [lowStockIngredients, setLowStockIngredients] = useState([]);

    useEffect(() => {
        setExpiringIngredients(notificationService.getExpiringSoon());
        setLowStockIngredients(notificationService.getLowStock());
    }, []);

    return (
        <div>
            <h2>🔔 Notifikace</h2>

            {expiringIngredients.length === 0 && lowStockIngredients.length === 0 ? (
                <div className="shopping-guide">
                    <p>✅ Žádné upozornění – vše je v pořádku!</p>
                </div>
            ) : (
                <ListGroup>
                    {expiringIngredients.map((ingredient) => (
                        <ListGroup.Item key={ingredient.id} variant="warning">
                            ⚠️ Expirace položky <b>{ingredient.name}</b>! ⏳
                        </ListGroup.Item>
                    ))}
                    {lowStockIngredients.map((ingredient) => (
                        <ListGroup.Item key={ingredient.id} variant="danger">
                            ⚠️ Položka <b>{ingredient.name}</b> klesla pod minimální množství! 📉
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            )}
        </div>
    );
};

export default NotificationsPage;
